import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER =
    "http://www.localhost:8888/back-end-endpoint-player-scout-search.php";
} else {
  API_SERVER = "/back-end-endpoint-player-scout-search.php";
}

const PlayerScoutSearch = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },

  show(id) {
    return HTTP.get(`users/${id}`);
  },

  store(post) {
    return HTTP.post(API_SERVER, post);
  },

  update(post, id) {
    return HTTP.put(`users/${id}`, post);
  },

  delete(params) {
    return HTTP.delete(API_SERVER, params);
  },

  // Data Health Methods
  getDataHealthMetrics(leagueId = null, teamId = null) {
    return HTTP.post(API_SERVER, {
      action: 'getDataHealthMetrics',
      leagueId: leagueId,
      teamId: teamId
    });
  },

  queueDataRefresh(type, ids, category = null, priority = 'normal') {
    return HTTP.post(API_SERVER, {
      action: 'queueDataRefresh',
      type: type,
      ids: ids,
      category: category,
      priority: priority
    });
  },
};

export { PlayerScoutSearch };
